
interface VueInterface {
  profile: IdTokenClaims;
}

import { AxiosResponse } from 'axios';
import { bus } from '@/main';
import { DataTableHeader } from 'vuetify';
import FileGroup from '@/models/fileGroup';
import { IdTokenClaims } from '@/auth/idTokenClaims';
import { mapState } from 'vuex';
import Vue from 'vue';
import { VueConstructor } from 'vue/types/vue';

const LightningDatabases = (Vue as VueConstructor<Vue & VueInterface>).extend({
  computed: {
    ...mapState<IdTokenClaims>('userStore', {
      profile: 'profile',
    }),
  },

  created() {
    this.selectedCompanyId = this.$route.params.companyId;
    this.refreshLightningCompanies();
  },

  data() {
    return {
      databases: [] as FileGroup[],
      dbsLoaded: false,
      lightningCompanies: [] as { id: string; name: string }[],
      selectedDb: [] as FileGroup[],
      selectedCompanyId: null as string | null,
      selectedCompanyName: null as string | null,
      showDeleteDbWarning: false,
      tableHeaders: [
        { text: '', value: 'id', width: '40px' },
        { text: 'Database Name', value: 'displayName', width: '500px' },
        { text: 'Uploaded', value: 'uploadedDT', width: '200px' },
        { text: '', value: 'test' },
      ] as DataTableHeader[],
      tableOptions: {
        page: 1,
        itemsPerPage: 30
      },
    };
  },

  methods: {
    changeCompany() {
      let lightningCompany = this.lightningCompanies.find((c) => c.id === this.selectedCompanyId);
      this.selectedCompanyName = lightningCompany ? lightningCompany.name : '';
      this.refreshLightningDbs();
    },

    deleteDb() {
      let companyIdParam = '&companyId=' + this.selectedDb[0].companyGuid;
      let userIdParam = 'userAzureADId=' + this.profile.sub;
      this.$http
        .delete('fileGroup?' + userIdParam + companyIdParam + '&id=' + this.selectedDb[0].id)
        .then(() => {
          let dbIndex = this.databases.findIndex((i) => i.id === this.selectedDb[0].id);
          this.databases.splice(dbIndex, 1);
          this.showDeleteDbWarning = false;
        })
        .catch((error) => {
          this.showDeleteDbWarning = false;
          bus.$emit('alert', 'Delete lightning database failed ', 'error', 6000, error);
        });
    },

    displayUploadedDT(dtString: string | null) {
      if (!dtString) return 'N/A';
      const noZ = dtString?.toString().indexOf('Z') === -1;
      let dt = new Date(dtString + (noZ ? 'Z' : ''));
      return dt.toLocaleDateString() + ' ' + dt.toLocaleTimeString();
    },

    refreshLightningCompanies() {
      this.$http.get<never>('fileGroupCompany').then((result: AxiosResponse<{ id: string; name: string }[]>) => {
        this.lightningCompanies = result.data;
        if (!this.selectedCompanyId && this.lightningCompanies.length > 0) {
          this.selectedCompanyId = this.lightningCompanies[0].id;
          this.selectedCompanyName = this.lightningCompanies[0].name;
        }
        this.refreshLightningDbs();
      });
    },

    refreshLightningDbs() {
      this.dbsLoaded = false;
      let query = 'fileGroup' + (this.selectedCompanyId ? '?companyId=' + this.selectedCompanyId : '');
      this.$http.get<never>(query).then((result: AxiosResponse<FileGroup[]>) => {
        this.databases = result.data;
        this.dbsLoaded = true;
      });
    },

    rowClick(item: FileGroup, row: { select: (value: boolean) => void }) {
      row.select(true);
    },
  },
});

export default LightningDatabases;
